export const ENERGY_MAX = 5;
const RECOVERY_INTERVAL_MS = 12 * 60 * 60 * 1000; // 1 energy per 12 hours = 2 per day

export function computeCurrentEnergy(stored: number, updatedAt: Date, now: Date): number {
  const elapsed = now.getTime() - updatedAt.getTime();
  const recovered = Math.floor(elapsed / RECOVERY_INTERVAL_MS);
  return Math.min(stored + recovered, ENERGY_MAX);
}

// Returns ms until the next energy point will be recovered (0 if already at max)
export function msUntilNextEnergy(stored: number, updatedAt: Date, now: Date): number {
  if (stored >= ENERGY_MAX) return 0;
  const elapsed = now.getTime() - updatedAt.getTime();
  const msIntoInterval = elapsed % RECOVERY_INTERVAL_MS;
  return RECOVERY_INTERVAL_MS - msIntoInterval;
}
